import props from "./../../../src-utils/propDefiner";

export default {
  ...props("value", String, "pm-custom"),
};
